import { injectable } from "@codemation/core";
import type { BootRuntimeSummary } from "./BootRuntimeSummary.types";

@injectable()
export class BootRuntimeSnapshotHolder {
  private snapshot: BootRuntimeSummary | null = null;

  set(snapshot: BootRuntimeSummary | null): void {
    this.snapshot = snapshot;
  }

  get(): BootRuntimeSummary | null {
    return this.snapshot;
  }
}
